import React from "react";
import "./FeaturedCompany.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import featuredCompaniesObjectList from "../../objects/FeaturedCompanies";
import featuredBrands from "../../assets/images/riso_featured_brands.png";

const FeaturedCompany = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Set autoplay speed in milliseconds
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  return (
    <div className="featuredcomp_container ">
      <div className="heading">
        <h2 className="section_heading">Featured companies</h2>
      </div>
      <div className="featuredcomp_card_container">
        <Slider {...settings} className="featuredcomp_slider">
          {featuredCompaniesObjectList.map((obj, index) => {
            return (
              <div className="featuredcomp_img_container" key={index}>
                <img src={featuredBrands} alt="" />
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default FeaturedCompany;
